<div class="margin">
  <div>
    <div *ngIf="implementToBeInspected === undefined"> {{"Please select an Implement to inspect first!" | translate | async}} </div>
    <div *ngIf="implementToBeInspected !== undefined">
      <div class="implement-overview">
        <!--<img style="height: 250px;" [src]="getDisplayImage()" (click)="viewImplementImage(inspectionImg)" />-->
        <img style="height: 250px; width: 333px; cursor: pointer;" title="Click to view/replace image." [src]="implementImage"
             (click)="viewImplementImage()" />
        <div class="implement-overview__content">
          <div class="content__primary">
            <div>
              <mat-form-field>
                <mat-select [(ngModel)]="selectedSchematic" [placeholder]="'Observation Point View' | translate | async">
                  <mat-option [value]='-999'>
                    {{implementToBeInspected.ImplementSerialNumber}}
                  </mat-option>
                  <!--<option [value]='-999' (click)="viewImplementLevel()">
                  {{implementToBeInspected.ImplementSerialNumber}}</option>-->
                  <!--<mat-option (click)="filterObPoint(item)" [value]="item.Id"
                    *ngFor="let item of implementToBeInspected?.AvailableShematics">
                    <img with="10" height="10" [src]="getImage(item.Image)">
                    {{item.FileName}}
                  </mat-option>-->
                </mat-select>
              </mat-form-field>

              <div>
                {{"Date Installed" | translate | async}}:
                <div> {{implementToBeInspected.DateInstalled | date:'yyyy-MM-dd'}}</div>
              </div>

              <div style="display: flex;  margin-top: 10%;">
                {{"Inspector" | translate | async}}:
                <div style="margin-left: 11px;"> {{implementToBeInspected.Inspector}}</div>
              </div>


              <div style="margin-top: 10px;" *ngIf="IsOnEquipment">
                {{"Equipment Smu at Install" | translate | async}}:
                <div> {{implementToBeInspected.EquipmentSmuAtInstall}}</div>
              </div>

              <div style="display: flex; margin-top: 4%;">


                <div style="display: flex; flex-direction: column;">
                  <b>{{"Inspection Date" | translate | async}}</b>
                  <mat-form-field style="margin-top:-10px">
                    <input class="custom-input" (click)=" picker.open()" matInput [matDatepicker]="picker"
                           [min]="minDate2" type="text"
                           [(ngModel)]="implementToBeInspected.InspectionDate" (ngModelChange)="dateChanged()">
                    <mat-datepicker #picker></mat-datepicker>

                  </mat-form-field>
                </div>

                <div style="display: flex; flex-direction: column;margin-left: 4%;">
                  <b>{{"Equipment SMU at Inspection" | translate | async}}</b>
                  <mat-form-field style="margin-top: -1px">
                    <input matInput type='number' (focusout)="UpdateSMU()"
                           [(ngModel)]="implementToBeInspected.MeterReading" #inputSMU (focus)="inputSMU.select()">
                  </mat-form-field>
                </div>

              </div>
            </div>
            <div style="display: flex; flex-direction: column; gap: 5%; width: 100%;">
              <div style="display: flex; justify-content: space-between; ">
                <div>
                  <mat-checkbox (ngModelChange)="inclideOnReportModelChanged($event)"
                                [ngModel]="implementToBeInspected.IncludeOnReport">{{"Include Cover Page on report" | translate | async}}</mat-checkbox>
                </div>
                <div>
                  <mat-checkbox (ngModelChange)="IncludeCommentOnReport(implementToBeInspected.IncludeCommentOnReport)"
                                [ngModel]="implementToBeInspected.IncludeOverallComment">{{"Include Overall Comment on Report" | translate | async}}</mat-checkbox>
                </div>
                <div style="display: flex; gap:2%; ">
                  <div style="margin-top: 3px;">
                    {{"Inspection Images" | translate | async}}
                  </div>
                  <div>
                    <photos-modal (onPhotoUpload)="newInspectionImageUploaded($event)" [comingFrom]="inspectionImages"
                                  [implementInspection]="implementToBeInspected"></photos-modal>
                  </div>
                  <div *ngFor="let inspectionImg of implementToBeInspected.InspectionImages">
                    <img *ngIf="inspectionImg.ImageData !== '' && inspectionImg.ImageData !== null"
                         (click)="ViewInspectionImage(inspectionImg)" class="observation-image__photo"
                         [src]="getImage(inspectionImg.ImageData)" />
                  </div>

                  <!--<span style="float: right; margin-top: 8px; z-index: 100;">
                    Inspection Images
                    <photos-modal (onPhotoUpload)="newInspectionImageUploaded($event)" [comingFrom]="inspectionImages"
                                  [implementInspection]="implementToBeInspected"></photos-modal>
                    <span *ngFor="let inspectionImg of implementToBeInspected.InspectionImages">
                      <img *ngIf="inspectionImg.ImageData !== '' && inspectionImg.ImageData !== null"
                           (click)="ViewInspectionImage(inspectionImg)" class="observation-image__photo"
                           [src]="getImage(inspectionImg.ImageData)" />
                    </span>
                  </span>-->
                </div>
              </div>
              <div style="margin-left: 50%; ">
                <div>
                  <div *ngIf="isCreatingInspection">
                    <mat-label>{{"Interpretation Comment" | translate | async}}</mat-label>
                    <textarea [(ngModel)]="implementToBeInspected.OverallComment" class="overalComment"></textarea>
                  </div>
                  <div *ngIf="!isCreatingInspection">
                    <edit-data dataType="textarea" [canEdit]="true" [placeholderText]="'Interpretation Comment' | translate | async" [(value)]="implementToBeInspected.OverallComment"
                               (valueChanged)="updateInterpretationComment($event,1)"></edit-data>
                  </div>
                </div>
                <div>
                  <div *ngIf="isCreatingInspection">
                    <mat-label>{{"Recommendation" | translate | async}}</mat-label>
                    <textarea [(ngModel)]="implementToBeInspected.Recommendation" class="overalComment"></textarea>
                  </div>
                  <div *ngIf="!isCreatingInspection">
                    <edit-data dataType="textarea" [canEdit]="true" [placeholderText]="'Recommendation'  | translate | async" [(value)]="implementToBeInspected.Recommendation"
                               (valueChanged)="updateInterpretationComment($event,2)"></edit-data>
                  </div>
                </div>
                <div>
                  <div *ngIf="isCreatingInspection">
                    <mat-label>{{"Work Required" | translate | async}}</mat-label>
                    <textarea [(ngModel)]="implementToBeInspected.WorkRequired" class="overalComment"></textarea>
                  </div>
                  <div *ngIf="!isCreatingInspection">
                    <edit-data dataType="textarea" [canEdit]="true" [placeholderText]="'Work Required'  | translate | async" [(value)]="implementToBeInspected.WorkRequired"
                               (valueChanged)="updateInterpretationComment($event,3)"></edit-data>
                  </div>
                </div>
              </div>
            </div>

            <!--<span [class.shouldResize]="!isCreatingInspection">-->
            <!-- <span style="scroll-margin-top: 10px;"> Inspection Comment</span> -->
            <!--<span *ngIf="isCreatingInspection">
              <br>



            </span>
            <span *ngIf="!isCreatingInspection" style="margin-top: 20px;">
              <br>-->
            <!--</span>

            </span>-->
          </div>

        </div>

      </div>
      <div class="content__secondary">
        <div style=" display: flex; gap: 2%;" *ngIf="implementToBeInspected?.GeneralQuestions?.length > 0">
          <div class="general-question" *ngFor="let question of implementToBeInspected.GeneralQuestions" style="display: flex;">
            <div>
              <photos-modal (onPhotoUpload)="questionImagesUploaded($event, question)"
                            [implementInspection]="implementToBeInspected" [comingFrom]="inspectiongeneralQuestionImage"
                            [inspectionGeneralQuestion]="question"></photos-modal>
            </div>
            <div *ngFor="let photo of question?.Image">
              <img class='observation-image__photo' (click)="viewGeneralQuestionOnImplmentImage(photo, question)"
                   *ngIf="photo.ImageData !== '' && photo.ImageData !== null " [src]='getImage(photo.ImageData)' />
            </div>
            <div style="display: flex; flex-direction: column;">
              <div class='question-title'> {{question.Description | translate | async}} </div>
              <div class='question-answers'>
                <mat-form-field style="width: 100px;">
                  <mat-select [(value)]="question.Answer.Id">
                    <mat-option (click)="answered(question, answer)" [value]="answer.Id"
                                *ngFor="let answer of question.PossibleAnswers">
                      {{answer.ResultDescription}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="general-question" style="display: flex; gap: 1%;">
          <div>
            <div class='question-title'>{{"Work Order" | translate | async}}</div>
            <div class='question-answers'>
              <mat-form-field style="margin-top: -1px">
                <input matInput type='text' [(ngModel)]="implementToBeInspected.WorkOrder"
                       #inputWO (focusout)="onWorkOrderFocusOut(implementToBeInspected.WorkOrder)">
              </mat-form-field>
            </div>
          </div>
          <div>
            <div class='question-title'>{{"Job File #" | translate | async}}</div>
            <div class='question-answers'>
              <mat-form-field style="margin-top: -1px; width: 250px;">
                <input matInput type='text' [disabled]="true" [(ngModel)]="implementToBeInspected.JobFileNo"
                       #inputJF>
              </mat-form-field>
            </div>
          </div>
          <div>
            <div class='question-title'>{{"Repair Request #" | translate | async}}</div>
            <div class='question-answers'>
              <mat-form-field style="margin-top: -1px; width: 250px;">
                <input matInput type='text' [disabled]="true" [(ngModel)]="implementToBeInspected.RepairRequestNo"
                       #inputRR>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div>

          <!-- <div  style="float:right;" [matMenuTriggerFor]="inspectionMenu"  >
            <button style="float:right;" mat-raised-button color="warn">PDF
            <i class="material-icons">save_alt</i>
          </button>

              <mat-menu #inspectionMenu="matMenu">
                <button mat-menu-item (click)="DownloadPDF(implementToBeInspected.InspectionStringDate)">{{implementToBeInspected.GETType + ' Report'}}</button>
                <button mat-menu-item (click)="DownloadTelerikPDF()">{{implementToBeInspected.GETType + ' Telerik Report'}}</button>
              </mat-menu>
          </div> -->
          <button *ngIf="isCreatingInspection" style="margin-left: 10%;float:right;" [class.loading]="isLoading"
                  matStepperNext mat-raised-button color="warn" (click)="SaveInspection()">
            {{"Save" | translate | async}}
            <i class="material-icons">done_outline</i>
          </button>
          <button *ngIf="!isCreatingInspection" style="float:right;" mat-raised-button color="warn"
                  (click)="DownloadTelerikPDF()">
            {{"PDF" | translate | async}}
            <i class="material-icons">save_alt</i>
          </button>
        </div>
      </div>
      <!-- TT-5753 Show Schematics and create observationPoints -->
      <div class="spiner_loader" *ngIf="isLoading">
        <mat-spinner></mat-spinner>
      </div>

      <div><span>{{"Select Schematic to add an observation point/Crack (Click on thumbnail)" | translate | async}}</span></div>
      <div style="overflow-x: scroll; white-space: nowrap; overflow-y: hidden;">


        <ng-container *ngFor="let sch of SchematicAndObservationPointList">
          <div class="implement-image-container2" [matTooltip]="!isCreatingInspection ? 'Click to view enlarged schematic.' : ''">
            <!--<img [src]="getImage_(sch.Schematic.Data)" class="selection__image" (click)="openSchematicWindow(sch)"
            style="width: 100%; height: 100%; margin-left: 22px;" />-->
            <img [src]="sch.Schematic.ImageUrl" class="selection__image" (click)="openSchematicWindow(sch)"
                 style="width: 100%; height: 100%;" />
            <input style="font-size: small;display: flex; justify-content: space-around;"
                   [(ngModel)]="sch.Schematic.Name">
          </div>
        </ng-container>
      </div>
      <!-- end TT-5753 -->
      <!--new code-->
      <div>
        <table class="table table--full-width table--striped" style="    margin-top: 9px;">
          <thead>
            <tr>
              <th>
                <div class="column-merge">
                  <div style="width: 150px; padding-left: 50px;">
                    {{"Component Type" | translate | async}}
                  </div>
                  <div>
                    {{"Component" | translate | async}}
                  </div>
                </div>
              </th>
              <!--<th style="padding: 16px 0px;">Component</th>-->
              <th>{{"Part#" | translate | async}}</th>
              <th style="cursor: pointer;" title="(Component Critical (C), Not Critical (N) and GET (G))">C/N/G</th>
              <th>{{"CMU" | translate | async}}</th>
              <th>{{"Residual" | translate | async}}</th>
              <th>{{"Observation Point" | translate | async}}</th>
              <th>{{"Type" | translate | async}}</th>
              <th>
                <div class="flex-div-col">
                  <div>
                    {{"Wear Limit" | translate | async}}({{userPref | uppercase}})
                  </div>
                  <div class="flex-div-row">
                    <div style="width: 50%;">0%</div>
                    <div style="width: 50%">100%</div>
                  </div>
                </div>
              </th>
              <th>{{"Question" | translate | async}}</th>
              <th>{{"Instructions" | translate | async}}</th>
              <th>{{"Measurement" | translate | async}}</th>
              <th style="padding-left: 30px;">{{"%Worn" | translate | async}}</th>
              <th>{{"Location" | translate | async}}</th>
              <th>
                <div style="padding: 0px 0px; max-width: 150px; width: 150px;">
                  {{"Obs. List" | translate | async}}
                </div>
              </th>
              <th>
                <div style="padding: 0px 0px; max-width: 150px; width: 150px;">
                  {{"Severity List" | translate | async}}
                </div>
              </th>
              <th>{{"Flag" | translate | async}}</th>
              <th>{{"Photo" | translate | async}}</th>
              <th>{{"Comment" | translate | async}}</th>
              <th *ngIf="!isCreatingInspection">{{"Delete" | translate | async}}</th>
              <th *ngIf="!isCreatingInspection">
                <div style="display: flex; flex-direction: column;">
                  <span>{{"Incl. Rep." | translate | async}}</span>
                </div>
              </th>
            </tr>
          </thead>

          <tbody>
            <ng-container *ngFor="let type of implementToBeInspected?.ComponentTypes">
              <tr style="background-color: #F0F4F8;">
                <td class="pad0">
                  <div style="display: flex; ">
                    <div>
                      <img class="comptype-schematic-image" *ngIf="!isCreatingInspection && type.SchematicPath !== ''"
                           [src]="type.SchematicPath" [title]="type.SchematicName" />
                    </div>
                    <div style="display: flex; align-items: center;"><b>{{type.componentTypeName}}</b></div>
                  </div>
                </td>
                <!--<td></td>-->
                <td class="pad0"> </td>
                <td class="pad0"> </td>
                <td class="pad0"> <span> <b>{{type.Life}}</b></span> </td>
                <td class="pad0"> <span> <b>{{type.Residual}}</b></span> </td>
                <td class="pad0"> </td>
                <td class="pad0"> </td>
                <td class="pad0"></td>
                <td class="pad0"></td>
                <!-- <td></td> -->
                <td class="pad0"> </td>
                <td class="pad0"> </td>
                <td class="pad0">
                  <div class="{{getEvalClass(type.Worn)}}  worn-percentage">
                    {{type.Worn}} %
                  </div>
                </td>
                <td class="pad0"> </td>
                <td class="pad0"> </td>
                <td class="pad0"></td>
                <td colspan="5" class="pad0">
                  <div *ngIf="!isCreatingInspection">
                    <textarea style="width: 400px;" [placeholder]="'Component Type comment for Report' | translate | async"
                              [(ngModel)]="type.CompTypeComment"
                              (change)="commentChanged(type.ReportOptionId,type.CompTypeComment)"></textarea>
                  </div>
                </td>
              </tr>
              <app-view-componenttype-points *ngIf="!isCreatingInspection" [observations]="observationsMap[type.componentTypeId + '_' + type.SchematicId]"
                                             [SchematicId]="type.SchematicId"
                                             [GETComponentTypeId]="type.componentTypeId"
                                             [implementID]="ImplementID"
                                             [implementInspectionId]="implementInspectionID"
                                             [inspectionDate]="implementToBeInspected.InspectionDate"
                                             (loaded)="onChildLoaded()">
              </app-view-componenttype-points>
              <ng-container *ngIf="isCreatingInspection">
                <ng-container *ngFor="let comp of implementToBeInspected?.Components">
                  <ng-container *ngIf="comp.GETComponentTypeId == type.componentTypeId">
                    <ng-container *ngIf="comp?.ObservationPoints?.length >0 && isCreatingInspection">
                      <tr *ngFor="let ob of comp.ObservationPointsFiltered">
                        <td class="pad0">
                          <div class="column-merge">
                            <div style="width: 150px;">

                            </div>
                            <div>
                              <span> {{ob?.ComponentName }} </span>
                            </div>
                          </div>
                        </td>
                        <td class="pad0">
                          <span> {{ob?.PartNumber }} </span>
                        </td>
                        <td class="pad0">
                          <span> {{ob?.CNG }} </span>
                        </td>
                        <td class="pad0">
                          <span> 0 </span>
                        </td>
                        <td class="pad0"><span>0</span></td>
                        <td class="pad0">{{ob.ObservationName}} </td>
                        <td class="pad0">{{ob.ObservationTypeName}} </td>
                        <td class="pad0" *ngIf="ob.ObservationTypeName =='Evaluation' || ob.ObservationTypeName =='Selection' || ob.ObservationTypeName =='Pass/Fail' || ob.ObservationTypeName =='Yes/No'">N/A </td>
                        <td class="pad0" *ngIf="ob.ObservationTypeName !='Evaluation' && ob.ObservationTypeName !='Selection' && ob.ObservationTypeName !='Pass/Fail' && ob.ObservationTypeName !='Yes/No'">
                          <div style="display: flex; justify-content: space-between; width: 100%;">
                            <div style="width: 50%;">{{ob.LimitNew}}</div>
                            <div style="width: 50%;">{{ob.LimitScrap}}</div>
                          </div>
                        </td>
                        <td class="pad0 margin-right">
                          <div class="observation-question">
                            <i title="Observation Questions" class="material-icons upload-container__icon">
                              message
                            </i>
                          </div>
                        </td>
                        <td class="pad0">
                          <div class="observation-question">
                            <i title="Question Image & Instructions" class="material-icons">rate_review</i>
                          </div>
                        </td>
                        <td class="pad0">&nbsp; </td>
                        <td class="pad0" *ngIf="ob.ObservationTypeId !=3 && ob.ObservationTypeId!=4 && ob.ObservationTypeId!=5 && ob.ObservationTypeId!=6">
                          <div class="{{getEvalClass(ob.WornPercentage)}}  worn-percentage">
                            {{ob.WornPercentage}} %
                          </div>
                        </td>
                        <td class="pad0" *ngIf="ob.ObservationTypeId ==3 || ob.ObservationTypeId ==4 || ob.ObservationTypeId ==5 || ob.ObservationTypeId ==6">
                          <div class="{{getEvalClass2(ob.WornPercentage)}}  worn-percentage">
                            U
                          </div>
                        </td>
                        <td class="pad0">&nbsp;</td>
                        <td class="pad0"> <i title="Observation Flag" class="material-icons">flag</i></td>
                        <td class="pad0">
                          <span *ngFor="let image of observation?.ObservationImages">
                            <img class="observation-image__photo" (click)="viewObservationImages(image)" *ngIf="image.ImageData !== ''" [src]="getImage(image.ImageData)">
                          </span>
                        </td>
                        <td class="pad0">
                          <div class="observation-question">
                            <i class="material-icons upload-container__icon">
                              message
                            </i>
                          </div>
                        </td>
                        <td class="pad0" *ngIf="!isCreatingInspection">&nbsp;</td>
                        <td class="pad0 margin-right" *ngIf="!isCreatingInspection">
                          <mat-checkbox disabled id="chkObservation-{{observation.Id}}" [checked]="observation?.IncludeReport" style="margin-left: 34%;" color="primary">
                          </mat-checkbox>
                        </td>
                        <td class="pad0">&nbsp;</td>
                      </tr>
                    </ng-container>


                  </ng-container>



                </ng-container>
              </ng-container>
            </ng-container>

          </tbody>

        </table>




        <!--<table class="table table--full-width table--striped" style="    margin-top: 9px;">
        <thead>
          <tr>
            <th>
              <div style="display: flex; gap: 20px;">
                <div style="width: 150px; padding-left: 50px;">
                  Component Type
                </div>
                <div>
                  Component
                </div>
              </div>
            </th>-->
        <!--<th style="padding: 16px 0px;">Component</th>-->
        <!--<th>Part#</th>
            <th style="cursor: pointer;" title="(Component Critical (C), Not Critical (N) and GET (G))">C/N/G</th>
            <th>CMU</th>
            <th>Residual</th>
            <th>Observation Point </th>
            <th>Type</th>
            <th>
              <div class="flex-div-col">
                <div>
                  Wear Limit({{userPref | uppercase}})
                </div>
                <div class="flex-div-row">
                  <div style="width: 50%;">0%</div>
                  <div style="width: 50%">100%</div>
                </div>
              </div>
            </th>
            <th>Question</th>
            <th>Instructions</th>
            <th>Measurement</th>
            <th style="padding-left: 30px;">%Worn</th>
            <th>
              <div style="padding: 0px 0px; max-width: 150px; width: 150px;">
                Obs. List
              </div>
            </th>
            <th>
              <div style="padding: 0px 0px; max-width: 150px; width: 150px;">
                Severity List
              </div>
            </th>
            <th>Flag</th>
            <th>Photo</th>
            <th>Comment</th>
            <th *ngIf="!isCreatingInspection">Delete</th>
            <th *ngIf="!isCreatingInspection">
              <div style="display: flex; flex-direction: column;">
                <span>Incl. Rep.</span>
              </div>
            </th>
          </tr>
        </thead>

        <tbody>-->
        <!--<app-view-componenttype-points *ngFor="let id of renderIds; let i = index"
                                       [GETComponentTypeId]="id"
                                       [index]="i"
                                       [implementID]="ImplementID"
                                       [implementInspectionId]="implementInspectionID"
                                       [inspectionDate]="implementToBeInspected.InspectionDate">
        </app-view-componenttype-points>-->
        <!--</tbody>-->
        <!--<app-view-componenttype-points  *ngIf="currentIndex < implementToBeInspected?.ComponentTypeIds?.length"
        [GETComponentTypeId]="implementToBeInspected?.ComponentTypeIds[currentIndex]"
                                               [implementID]="ImplementID"
                                               [implementInspectionId]="implementInspectionID"
                                               [inspectionDate]="implementToBeInspected.InspectionDate"
                                               (loadDone)="onChildLoaded()">
                </app-view-componenttype-points>-->
        <!--<tbody>
        <tr style="background-color: #F0F4F8;">
          <td>
            <div style="display: flex; ">
              <div>
                <img class="comptype-schematic-image" *ngIf="types.SchematicPath !== ''"
                     [src]="types.SchematicPath" [title]="types.SchematicName" />
              </div>
              <div style="display: flex; align-items: center;"><b>{{types.componentTypeName}}</b></div>
            </div>
          </td>-->
        <!--<td></td>-->
        <!--<td> </td>
        <td> </td>
        <td> <span> <b>{{types.Life}}</b></span> </td>
        <td> <span> <b>{{types.Residual}}</b></span> </td>
        <td> </td>
        <td> </td>
        <td></td>
        <td></td>-->
        <!-- <td></td> -->
        <!--<td> </td>
          <td> </td>
          <td>
            <div class="{{getEvalClass(types.Worn)}}  worn-percentage">
              {{types.Worn}} %
            </div>
          </td>
          <td> </td>
          <td></td>
          <td colspan="5" style="padding: 0px;">
            <div *ngIf="!isCreatingInspection">
              <textarea style="width: 400px;" placeholder="Component Type comment for Report"
                        [(ngModel)]="types.CompTypeComment"
                        (change)="commentChanged(types.ReportOptionId,types.CompTypeComment)"></textarea>
            </div>
          </td>
        </tr>-->
        <!--<ng-container *ngFor="let comp of implementToBeInspected?.Components">
          <ng-container *ngIf="comp.GETComponentTypeId == types.GETComponentTypeId">
            <ng-container *ngIf="comp?.ObservationPoints?.length >0 && isCreatingInspection">
              <tr *ngFor="let ob of comp.ObservationPointsFiltered">
                <td>
                  <div style="display: flex; gap: 20px;">
                    <div style="width: 150px;">

                    </div>
                    <div>
                      <span> {{ob?.ComponentName }} </span>
                    </div>
                  </div>
                </td>
                <td>
                  <span> {{ob?.PartNumber }} </span>
                </td>
                <td>
                  <span> {{ob?.CNG }} </span>
                </td>
                <td>
                  <span> 0 </span>
                </td>
                <td><span>0</span></td>
                <td>{{ob.ObservationName}} </td>
                <td>{{ob.ObservationTypeName}} </td>
                <td *ngIf="ob.ObservationTypeName =='Evaluation' || ob.ObservationTypeName =='Selection' || ob.ObservationTypeName =='Pass/Fail' || ob.ObservationTypeName =='Yes/No'">N/A </td>
                <td *ngIf="ob.ObservationTypeName !='Evaluation' && ob.ObservationTypeName !='Selection' && ob.ObservationTypeName !='Pass/Fail' && ob.ObservationTypeName !='Yes/No'">
                  <div style="display: flex; justify-content: space-between; width: 100%;">
                    <div style="width: 50%;">{{ob.LimitNew}}</div>
                    <div style="width: 50%;">{{ob.LimitScrap}}</div>
                  </div>
                </td>
                <td class="margin-right">
                  <div class="observation-question">
                    <i title="Observation Questions" class="material-icons upload-container__icon">
                      message
                    </i>
                  </div>
                </td>
                <td>
                  <div class="observation-question">
                    <i title="Question Image & Instructions" class="material-icons">rate_review</i>
                  </div>
                </td>
                <td>&nbsp; </td>
                <td *ngIf="ob.ObservationTypeId !=3 && ob.ObservationTypeId!=4 && ob.ObservationTypeId!=5 && ob.ObservationTypeId!=6">
                  <div class="{{getEvalClass(ob.WornPercentage)}}  worn-percentage">
                    {{ob.WornPercentage}} %
                  </div>
                </td>
                <td *ngIf="ob.ObservationTypeId ==3 || ob.ObservationTypeId ==4 || ob.ObservationTypeId ==5 || ob.ObservationTypeId ==6">
                  <div class="{{getEvalClass2(ob.WornPercentage)}}  worn-percentage">
                    U
                  </div>
                </td>

                <td>&nbsp;</td>
                <td> <i title="Observation Flag" class="material-icons">flag</i></td>
                <td>
                  <span *ngFor="let image of observation?.ObservationImages">
                    <img class="observation-image__photo" (click)="viewObservationImages(image)" *ngIf="image.ImageData !== ''" [src]="getImage(image.ImageData)">
                  </span>
                </td>
                <td>
                  <div class="observation-question">
                    <i class="material-icons upload-container__icon">
                      message
                    </i>
                  </div>
                </td>
                <td *ngIf="!isCreatingInspection">&nbsp;</td>
                <td *ngIf="!isCreatingInspection" class="margin-right">
                  <mat-checkbox disabled id="chkObservation-{{observation.Id}}" [checked]="observation?.IncludeReport" style="margin-left: 34%;" color="primary">
                  </mat-checkbox>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="comp.ViewObservationPointsIds?.length > 0 && !isCreatingInspection">
              <app-view-observation-point-row *ngFor="let item of comp.ViewObservationPointsIds"
                                              [observationPointInspectionId]="item" [Residual]="comp.Residual" [implementID]="ImplementID"
                                              [implementInspectionId]="implementInspectionID"
                                              [inspectionDate]="implementToBeInspected.InspectionDate" style="cursor: default;">
              </app-view-observation-point-row>
            </ng-container>
          </ng-container>



        </ng-container>-->
        <!--</tbody>-->
        <!-- </ng-container>-->
        <!--</table>-->
      </div>

    </div>
    <!--end new code-->
  </div>
</div>

